import trackEvent from 'actions/analytics/trackEvent.action';
import PROMISE_STATUS from 'constants/promiseStatus.const';
import { COGNITO_ATTRIBUTE, updateUserAttributes } from 'utils/cognito.util';
import dispatch from 'utils/core/dispatch.util';
import allSettled from 'utils/functions/allSettled.util';
import logger from 'utils/logger.util';

const L = logger('finishOnboarding');

const EVENT_FINISHED = Object.freeze({ event: 'Finished Onboarding', properties: {} });
const ATTR_COMPLETED = Object.freeze({ [COGNITO_ATTRIBUTE.onboardingCompleted]: '1' });

const logDispatch = ({ reason, status }) => {
  if (status === PROMISE_STATUS.rejected) {
    L.warn('()', 'dispatchInfo:', reason);
  }
};

const logUpdate = ({ status, value, reason }, cognitoUser) => {
  if (status === PROMISE_STATUS.fulfilled) {
    L.info('()', 'Finished on-boarding for cognitoUser:', cognitoUser, 'with value:', value);
  } else {
    L.warn('()', 'Failed to finish on-boarding for cognitoUser:', cognitoUser, 'with reason:', reason);
  }
};

const finishOnboarding = async ({ cognitoUser }) => {
  // this way both can run in parallel
  const dispatchPromise = dispatch(trackEvent(EVENT_FINISHED));
  const updatePromise = updateUserAttributes({ cognitoUser, attributes: ATTR_COMPLETED });

  // this will make sure both have finished before continuing
  const [dispatchInfo, updateInfo] = await allSettled([dispatchPromise, updatePromise]);

  // allSettled will not throw rejections but put them in the array items, so log the useful info
  logDispatch(dispatchInfo);
  logUpdate(updateInfo, cognitoUser);

  return updatePromise;
};

// noinspection JSUnusedGlobalSymbols
export default finishOnboarding;
